const {
    SHOW_NOTIFICATION_DIALOG_MANUAL_PO_UPLOAD,
    HIDE_NOTIFICATION_DIALOG_MANUAL_PO_UPLOAD,
    SHOW_SECOND_DIALOG,
  } = require("./action-type");
  
  export const showNotificationDialogManualPOUpload = (
    title,
    content,
    buttonLabel1,
    buttonLabel2,
    url,
    showButton1,
    showButton2
  ) => {
    return {
      type: SHOW_NOTIFICATION_DIALOG_MANUAL_PO_UPLOAD,
      payload: { title, content, buttonLabel1, buttonLabel2, url, showButton1, showButton2 },
    };
  };
  
  export const hideNotificationDialogManualPOUpload = () => {
    return {
      type: HIDE_NOTIFICATION_DIALOG_MANUAL_PO_UPLOAD,
    };
  };
  
  export const showSecondDialog = (title, content) => {
    return {
      type: SHOW_SECOND_DIALOG,
      payload: { title, content },
    };
  };